export default __webpack_public_path__ + "static/media/greek-punch-wreath.85fa6ef0.svg";